module.exports = __webpack_public_path__ + "img/eloqua.5d3a617d.png";